import { Card, Container, Heading, Text, VStack } from "@chakra-ui/react";
import { SocialButtons } from "../../atoms";
import Header from "../../atoms/Header";
import { Footer } from "../../molecules";
import { useSelector } from "react-redux";
import { getData } from "../../../store/site/selectors";

export default function Maintenance() {
  const data = useSelector(getData);

  return (
    <>
      <Header />
      <Container maxW="4xl" p="50px">
        <Card p="20px">
          <VStack>
            <Heading size="base" fontSize="1.2em">
              Oh oh, ci hai beccato lavorare sul sito 🔧
            </Heading>
            <Text fontSize="1.1em" textAlign="center" my="20px">
              Non temere, torneremo presto online.
              <br />
              Intanto per qualsiasi info contattaci sui nostri social o via
              email a
              <Text as="span" fontWeight="bold">
                &nbsp;talesmontagnana@gmail.com
              </Text>
            </Text>
            <SocialButtons />
            <Heading size="base" fontSize="1.2em" mt="20px">
              Ti aspettiamo il {data}!
            </Heading>
          </VStack>
        </Card>
      </Container>

      <Footer />
    </>
  );
}
